export default __webpack_public_path__ + "static/media/mercado.f70f7578.jpg";